import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#7986CB', // 파스텔 인디고
                secondary: '#9575CD', // 파스텔 딥퍼플
                accent: '#64B5F6', // 파스텔 블루
                background: '#F5F7FA', // 연한 그레이
            }
        }
    }
})